export const COMPRESSION_CONFIG = {
  maxSizeMB: 4,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
} as const

export type CompressionConfig = typeof COMPRESSION_CONFIG
